/**
 * Raised when an action is blocked by the account's plan rather than by a
 * server or network failure, so the UI can offer an upgrade instead of a
 * generic "something went wrong".
 */
export class PlanLimitError extends Error {
  constructor(message = "Plan limit reached") {
    super(message);
    this.name = "PlanLimitError";
  }
}

export function isPlanLimitError(error) {
  return error instanceof PlanLimitError;
}
